/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  accessGroupData,
  setIsExternal
}) {
  try {

    if(!accessGroupData) {
      const qst1967 = questionnaire.find(question => question.idQuestion === 1967);
      const qst1969 = questionnaire.find(question => question.idQuestion === 1969);

      if (!qst1967.answer) {
        qst1969.disabled = true;
        qst1969.behaviorObject.isReadOnly = true;
      }

      return questionnaire;
    }
    
    //  Group Section  initial adjustments
    return questionnaire.map(question => {

      if(question.idQuestion === 1976){
        question.answer = accessGroupData.idGroup;
        accessGroupData.idGroup && setFieldValue(question.key, accessGroupData.idGroup);
      }
  
      if(question.idQuestion === 1966){
        question.answer = accessGroupData.groupName;
        question.behaviorObject.isRequired = true;
        accessGroupData.groupName && setFieldValue(question.key, accessGroupData.groupName);
      }
      
      if(question.idQuestion === 1967){
        const groupTypeOption = accessGroupData.behavior?.isExternalAccessGroup ? 7627 : 7626;

        const selectedOption = question.answerOptions.find(option => option.idAnswerOption === groupTypeOption);

        const result = {
          idAnswerOption: selectedOption?.idAnswerOption,
          dsAnswerOption: selectedOption?.dsAnswerOption,
          resultValue: selectedOption?.behaviorObject?.resultValue || null
        };

        question.answer = selectedOption?.dsAnswerOption;
        question.answerJson = selectedOption.answerJson;
        question.idAnswerOption = selectedOption?.idAnswerOption;
        setFieldValue && setFieldValue(question.key, result);
        setIsExternal(selectedOption?.idAnswerOption === 7627);

        const maxValueRange = questionnaire.find(qst => qst.idQuestion === 1968);
        if (maxValueRange) maxValueRange.visibleQuestion = groupTypeOption === 7626;

        questionnaire.find(question => question.idQuestion === 1969).behaviorObject.isExternal = groupTypeOption === 7627;
      }
      
      if(question.idQuestion === 1968){
        const grpMembershipData = accessGroupData.accessGroupMemberships.find(grpMembership => grpMembership.idDomain === 790);
        if(grpMembershipData){
          question.answer = grpMembershipData?.maxOperationAmount;
          grpMembershipData?.maxOperationAmount && setFieldValue(question.key, grpMembershipData?.maxOperationAmount);
        }
      }
      
      if(question.idQuestion === 1969){
        const grpMembershipData = accessGroupData.accessGroupMemberships.find(grpMembership => grpMembership.idDomain === 308);
        
        if(grpMembershipData){
          question.answer = JSON.stringify({value: grpMembershipData.groupParentName, id: grpMembershipData.idGroupParent}); //grpMembershipData.groupParentName;
          question.answerJson = JSON.stringify({value: grpMembershipData.groupParentName, id: grpMembershipData.idGroupParent});
          setFieldValue(question.key, grpMembershipData?.groupParentName);
        }
      }

      return question;
    });
  } catch (e) {
    console.log("ACCESS_GROUP  - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  idAccessGroup,
  setIsExternal,
  mc,
  getDescription
}) {
  try {
    let saveFilteredQuestionnaire = false;
   
    if(question.idQuestion === 1967){
      saveFilteredQuestionnaire = true;
      setIsExternal(value.idAnswerOption === 7627);
      const qst1980 = questionnaireUpdated.find(question => question.idQuestion === 1980);

      qst1980.behaviorObject.isExternal = value.idAnswerOption === 7627;
      qst1980.answer = '';
      qst1980.answerJson = '';
      setFieldValue(qst1980.key, '');
      
      const qst1969 = questionnaireUpdated.find(question => question.idQuestion === 1969);
      qst1969.behaviorObject.isExternal = value.idAnswerOption === 7627;
      qst1969.answer = '';
      qst1969.answerJson = '';
      setFieldValue(qst1969.key, '');

      if (value) {
        qst1969.disabled = false;
        qst1969.behaviorObject.isReadOnly = false;
      } else {
        qst1969.disabled = true;
        qst1969.behaviorObject.isReadOnly = true;
      }

      const maxValueRange = questionnaireUpdated.find(qst => qst.idQuestion === 1968);
      if (maxValueRange) {
        maxValueRange.visibleQuestion = value?.idAnswerOption === 7626;
        maxValueRange.answer = '';
        setFieldValue && setFieldValue(maxValueRange.key, '');
      }
    }
  
    if (question.idQuestion === 1969 && idAccessGroup) question.behaviorObject.idAccessGroup = idAccessGroup;

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);

  } catch (e) {
    console.log("ACCESS_GROUP - handleQuestionChange error", e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange
}

export { events };